import React from "react";

/**
 * Standard empty state for the employee profile subtabs:
 * a gray icon circle, a title, optional description, and an optional CTA.
 */
function EmployeeProfileEmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="text-center py-12 px-6">
      {Icon && (
        <div className="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon className="text-gray-400" style={{ fontSize: "28px" }} />
        </div>
      )}
      <h3 className="text-base font-semibold text-gray-900 mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-gray-500 max-w-sm mx-auto">{description}</p>
      )}
      {action && <div className="mt-5 flex justify-center">{action}</div>}
    </div>
  );
}

export default EmployeeProfileEmptyState;
